import { IRestfulConfigMap } from "@core/data-access/restful";
import { envConfig } from "@env/env-config";


let LocationTypeServiceConfig: IRestfulConfigMap = {
    "locationTypeConfigService": {
        appPath: envConfig.appPath("base"),
        isAuth: true,
        actions: {
            // 获取地址locationType配置
            getLocationType:{
                method: "get",
                path: "/api/locationTypeConfigs/list",
                testPath: "/api/locationTypeConfigs/list"
            }
        }
    }
}

export { LocationTypeServiceConfig };